// extracted by mini-css-extract-plugin
module.exports = {"root":"popover-content-title_root__4XbN4","highlight":"popover-content-title_highlight__FwMXE"};